import React, {useState} from 'react';
import {Trans} from 'react-i18next';
import {history} from '../../../../utils/redux/store';
import Select from 'react-select';
import UnSavedModal from '../unSavedModal';

export default function SelectedPageHeader({
  groupedOptions,
  selectedPage,
  setSelectedPage,
  dirty,
}) {
  const [targetUrl, setTargetUrl] = useState('');
  const [showDialog, setShowDialog] = useState(false);

  if (!selectedPage) {
    return <div />;
  }

  return (
    <>
      <h4 style={{width: '50%'}} className="d-flex">
        <div
          className="kt-margin-r-10 cursor-pointer"
          onClick={() =>
            history.push('/skincare-pro/ui-configuration/overview')
          }
        >
          <i className="fa fa-arrow-left" />
        </div>
        {selectedPage.label}
      </h4>
      <div
        className="d-flex"
        style={{
          width: '50%',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Trans i18nKey="p.s.uiconfiguration.header.jump">Jump to</Trans>
        <div style={{width: '240px', marginLeft: '20px'}}>
          <Select
            value={selectedPage}
            onChange={e => {
              if (dirty) {
                setTargetUrl(e.value);
                setShowDialog(true);
              } else {
                setSelectedPage(e);
              }
            }}
            options={groupedOptions.filter(o => o.show)}
            formatGroupLabel={data => <h6>{data.label}</h6>}
          />
        </div>
      </div>
      <UnSavedModal
        showModal={showDialog}
        setShowModal={setShowDialog}
        handleLeave={() => history.push(targetUrl)}
      />
    </>
  );
}
